<template>
    <span class="email-wrapper">
        <input type="email"
               :title="validationMessage"
               :class="`form__field form__field--email ${(this.def ? `form__field--${this.def} --${this.def} js-${this.def}` : '' )}`"
               :name="def" :id="def" :ref="def"
               :placeholder="placeholder"
               :autofill="true"
               :readonly="readOnly"
               :value="internalValue"
               :disabled="disabled"
               @input="onInput"
               @change="onChange"
               @keydown="$emit('keydown', $event)"
               @keypress="$emit('keypress', $event)"
               @keyup="$emit('keyup', $event)"
               @keyup.enter="$emit('keyup.enter', $event)"
               @mousedown="$emit('mousedown', $event)"
               @mouseover="$emit('mouseover', $event)"
               @mouseup="$emit('mouseup', $event)"
               @touchstart="$emit('touchstart', $event)"
               @touchend="$emit('touchend', $event)"
               @touchcancel="$emit('touchcancel', $event)">
    </span>
</template>

<script>

import FormControlText from './form-control-text'

export default {

    props: {
        def: {
            type: String,
            default: 'email',
        },
        validationMessage: {
            type: String,
            default: 'Please provide a valid email address.',
        },
    },

    mixins: [
        FormControlText,
    ],
}

</script>
